import { UserRole } from '@/components/authnz/types/rbac';

export type GrantSource = 'admin' | 'subscription' | 'seed';

export type GrantChip = {
  role: UserRole;
  source: GrantSource;
};

export type PrototypeRow = {
  emailKey: string;
  lifecycle: 'existing' | 'deleted';
  grants: GrantChip[];
  lastSignIn: string | null;
  knownUids: number;
  invitedNotSignedIn: boolean;
  authExists: boolean;
  authDisabled: boolean;
  emailVerified: boolean;
  activeSubscriptions: string[];
  lastSessionError: string | null;
  lastSignInLinkSend: string | null;
  fallbackLegacy: boolean;
};

export type PrototypeAction =
  | { type: 'assign'; emailKey: string; role: UserRole }
  | { type: 'revoke-admin'; emailKey: string; role: UserRole }
  | { type: 'delete'; emailKey: string }
  | { type: 'restore'; emailKey: string }
  | { type: 'invite'; emailKey: string; role: UserRole }
  | { type: 'move-email'; from: string; to: string }
  | { type: 'copy-link'; emailKey: string }
  | { type: 'send-link'; emailKey: string };

export const SELF_EMAIL = 'admin.test@example.com';
export const FALLBACK_HITS = 6;
